@if(intervention){
<!-- intervention chargé -->

<td tuiTd>
    {{ intervention!.type?.libelle }}
</td>

<td tuiTd>
    {{ intervention!.dateDeRealisation | date:'dd/MM/yyyy' }}
</td>

@if(format == 'O2'){

<td tuiTd [class]="['statut-info']">
    {{ intervention!.deambulation?.value ?? '--'}}
</td>

<td tuiTd [class]="['statut-' + (intervention!.obs | obsStatut)]">
    {{ (intervention!.obs?.value | obs) ?? '--'}}
</td>

<td tuiTd [class]="['statut-info']">
    {{ intervention!.debit02Repos?.value ?? '--'}} - {{ intervention!.debit02Effort?.value ?? '--'}}
</td>

<td tuiTd [class]="['statut-info']">
    {{ intervention!.duree?.value ?? '--'}}
</td>

} @else {

@if(format == 'VENTI'){

<td tuiTd [class]="['statut-info']">
    {{ intervention!.vt?.value ?? '--' }}
</td>

} @else {

<td tuiTd [class]="['statut-info']">
    {{ (intervention!.p90_95?.value | pression) ?? '--' }}
</td>

}


<td tuiTd [class]="['statut-' + (intervention!.obs | obsStatut)]">
    {{ (intervention!.obs?.value | obs) ?? '--'}}
</td>

<td tuiTd [class]="['statut-' + (intervention!.iahResiduel | iahResiduelStatut)]">
    {{ (intervention!.iahResiduel?.value | iahResiduel) ?? '--' }}
</td>

<td tuiTd [class]="['statut-' + (intervention!.fuites | fuitesStatut)]">
    {{ (intervention!.fuites?.value | fuites) ?? '--' }}
</td>

}

<td tuiTd>
    @if(intervention!.commentaire){
    <div tuiComment="left" tuiHintAppearance="light" tuiHintDirection="left" [tuiHint]="tooltip"
        [ngClass]="{'comment' : true}">
        &nbsp;&nbsp;...&nbsp;&nbsp;
    </div>
    <ng-template #tooltip>
        <div>
            {{ intervention!.commentaire.value }}
        </div>
    </ng-template>
    } @else {
    <div tuiComment="left">
        &nbsp;&nbsp;ø&nbsp;&nbsp;
    </div>
    }
</td>

<td tuiTd>
    @if(intervention!.compteRendu){
    <button size="s" tuiButton type="button" appearance="outline"
        (click)="show(actions, intervention!.compteRendu!.id, 'Compte rendu')">
        Prévisualiser
    </button>
    }
</td>

<td tuiTd>
    @if(intervention!.rapportMachine){
    <button size="s" tuiButton type="button" appearance="outline"
        (click)="show(actions, intervention!.rapportMachine!.id, 'Rapport machine')">
        Prévisualiser
    </button>
    }
</td>
} @else{
<!-- intervention pas chargé -->

<td tuiTd class="placeholder">
    XXXXXX XXXXX XXX
</td>

<td tuiTd class="placeholder">
    00/00/0000
</td>

@if(format && format == 'O2'){

<td tuiTd [class]="['statut-info', 'placeholder']">
    XXX
</td>

<td tuiTd [class]="['statut-info', 'placeholder']">
    00h
</td>

<td tuiTd [class]="['statut-info', 'placeholder']">
    0 - 0
</td>

<td tuiTd [class]="['statut-info', 'placeholder']">
    00
</td>

} @else {

@if(format == 'VENTI'){

<td tuiTd [class]="['statut-info', 'placeholder']">
    0.00
</td>

} @else {

<td tuiTd [class]="['statut-info', 'placeholder']">
    0cmH2O
</td>

}


<td tuiTd [class]="['statut-info', 'placeholder']">
    00h
</td>

<td tuiTd [class]="['statut-info', 'placeholder']">
    0.00/h
</td>

<td tuiTd [class]="['statut-info', 'placeholder']">
    XXXXXX
</td>

}

<td tuiTd class="placeholder">
    <div tuiComment="left" [ngClass]="{'comment' : true}">
        &nbsp;&nbsp;ø&nbsp;&nbsp;
    </div>
</td>

<td tuiTd>
</td>

<td tuiTd>
</td>
}
<ng-template #actions let-content="content">
    <a download size="s" tuiButton [href]="content">
        Télécharger
    </a>
</ng-template>